import { API_CONFIG } from "../config/api";

interface CoordinatorActionPayload {
  alertId: string;
  actionType: "contact" | "dismissed" | "snoozed" | "resolved" | "follow_up";
  contactMethod?: "email" | "phone" | "sms" | "in_person" | null;
  coordinatorNotes?: string | null;
  studyId?: string;
  participantId?: string;
}

export const CoordinatorActionsService = {
  async saveAction(token: string | null, payload: CoordinatorActionPayload) {
    const base = API_CONFIG.BASE_URL || process.env.REACT_APP_API_URL || "";
    const url = `${base}/api/coordinator-actions/action`;

    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });

    if (!resp.ok) {
      let msg = `Failed to save coordinator action (${resp.status})`;
      try {
        const j = await resp.json();
        if (j?.error) msg = j.error;
      } catch {}
      throw new Error(msg);
    }

    return resp.json();
  },

  async getAlertActions(token: string | null, alertId: string) {
    const base = API_CONFIG.BASE_URL || process.env.REACT_APP_API_URL || "";
    const url = `${base}/api/coordinator-actions/alert/${alertId}`;

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!resp.ok) {
      let msg = `Failed to fetch coordinator actions (${resp.status})`;
      try {
        const j = await resp.json();
        if (j?.error) msg = j.error;
      } catch {}
      throw new Error(msg);
    }

    return resp.json();
  },

  async getStudyActions(
    token: string | null,
    studyId: string,
    limit: number = 100
  ) {
    const base = API_CONFIG.BASE_URL || process.env.REACT_APP_API_URL || "";
    const url = `${base}/api/coordinator-actions/study/${studyId}?limit=${limit}`;

    const resp = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });

    if (!resp.ok) {
      let msg = `Failed to fetch study coordinator actions (${resp.status})`;
      try {
        const j = await resp.json();
        if (j?.error) msg = j.error;
      } catch {}
      throw new Error(msg);
    }

    return resp.json();
  },
};
